export { default } from "./acknowledgmentsDialog";
